module.exports = __webpack_public_path__ + "img/SearchAD@3x.72af4906.png";